import React, { type FC, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { AppRoutes } from "@domain/routing/routeConstants";
import { DmsPaths } from "@domain/routing/dmsPaths";
import { ModuleNav, type NavItem } from "./ModuleNav";

export const ModuleDmsLinks: FC = () => {
    const { pathname = "" } = useLocation();
    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(
        () => [
            {
                key: AppRoutes.dms,
                to: AppRoutes.dms,
                label: "DMS",
            },
            {
                key: `${AppRoutes.dms}/${DmsPaths.AVIS}`,
                to: `${AppRoutes.dms}/${DmsPaths.AVIS}`,
                label: "AVIS",
            },
        ],
        [],
    );

    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};
